import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'smr-loading',
  templateUrl: './loading-smr.component.html',
  styleUrls: ['./loading-smr.component.scss']
})
export class LoadingSmrComponent implements OnInit {

  constructor() { }

  @Input() show: boolean;

  ngOnInit() {
  }

}
